module.exports = __webpack_public_path__ + "img/copy.cdaa5a24.svg";